import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import parse from 'html-react-parser';
/* import ReactHtmlParser from 'react-html-parser'; */

import { setModalData } from '../../reducers/commonSlice';
import { usePubSub } from '../../components/hooks/PubSubContext';
import { fetchGetUserComunicados } from '../../reducers/comunicadoSlice';

import './ComunicadoModal.scss';


function ComunicadoModal(props) {

    const dispatch = useDispatch();
    const { publish, subscribe, unSubscribe } = usePubSub();

    const logguedUserData = useSelector(state => state.common.logguedUserData);

    useEffect(() => {
        subscribe('messageOkClicked', handleOk);
        subscribe('messageCancelClicked', handleNo);

        loadData();

        return () => {
            unSubscribe('messageOkClicked');
            unSubscribe('messageCancelClicked');
        }
    }, []);

    const handleOk = (ev) => { publish('closeFullModal', null); console.log('clicked yes'); }
    const handleNo = (ev) => { publish('closeFullModal', null); console.log('clicked no'); }

    const loadData = async () => {
        const comunicados = await fetchGetUserComunicados({ filters: { conjunto_id: logguedUserData.conjunto_id } });

        console.log('reulst', comunicados.comunicadoList);

        if (comunicados.comunicadoList?.length > 0) {
            const datos = comunicados.comunicadoList?.map(cl => {
                return { content: getContent(cl) }
            });

            publish('openFullModal', {
                buttons: [
                    { label: 'No, leave it', onclick: handleNo, eventName: 'messageCancelClicked' },
                    { label: 'Yes, please', onclick: handleOk, positive: true, eventName: 'messageOkClicked' }
                ],
                contents: datos
            });
        }
    }

    const getContent = (cl) => {

        if (cl.texto.startsWith("<")) {
            return <div>{parse(cl.texto)}</div>;
        } else {
            return (
                <div className='comunicado-container' style={{ backgroundImage: "url(https://picsum.photos/id/512/880/500)" }}>
                    <img className='comunicado-logo' style={{ width: "30px" }} src='https://img.freepik.com/vector-premium/diseno-logotipo-icono-sauce_586739-1993.jpg' />
                    <div className='comunicado-titulo '>{cl.titulo}</div>
                    <div className='comunicado-contenido'>{cl.texto}
                    </div>
                </div>
            )
        }


    }

    return (
        <div >
        </div>
    );
}

export default ComunicadoModal;